import { lazy } from 'react';

const OsceStatsPage = lazy(() =>
  import('./osce-stats/page.js').then((module) => ({ default: module.OsceStatsPage })),
);
const OsceSessionsPage = lazy(() =>
  import('./sessions/page.js').then((module) => ({ default: module.OsceSessionsPage })),
);
const OsceSessionDetailPage = lazy(() =>
  import('./sessions/[id]/page.js').then((module) => ({ default: module.OsceSessionDetailPage })),
);
const OsceCalculatorPage = lazy(() =>
  import('./calculator/page.js').then((module) => ({ default: module.OsceCalculatorPage })),
);
const OsceStationsPage = lazy(() =>
  import('./stations/page.js').then((module) => ({ default: module.OsceStationsPage })),
);

export { OsceCalculatorPage, OsceSessionDetailPage, OsceSessionsPage, OsceStationsPage, OsceStatsPage };
